import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {currentResource} from '../../util/utils';
import _ from 'lodash';

export default function confidentialityTypesReducer(state = initialstate.confidentialityTypes, action) {
	switch (action.type) {
		case types.GET_ALL_CONFIDENTIALITY_TYPES:
			return getLocalizedConfidentialityTypes(action);
		default:
			return state;
	}
}

function getLocalizedConfidentialityTypes(action) {
	let confidentialityTypes = [];

	var localizedConfTypes = currentResource.ConfidentialityTypes;
	_.each(action.response, function(apiConfTypes) {
		let localConfType = localizedConfTypes.find((x) => x.id == apiConfTypes.id);
		let finalName = localConfType ? localConfType.Name : apiConfTypes.confidentialityTypeName;
		confidentialityTypes.push({
			id: apiConfTypes.id,
			name: finalName
		});
	});

	return confidentialityTypes;
}
